import request from '@/axios'
import type { UserType, UserLoginType, TwoFactorVerifyType } from './types'

interface RoleParams {
  roleName: string
}

interface LoginResponse {
  access_token: string
  expires_in: number
  user: UserType
}

interface TwoFactorRequiredResponse {
  requiresTwoFactor: boolean
  tempToken: string
  message: string
}

export const loginApi = (
  data: UserLoginType
): Promise<IResponse<LoginResponse | TwoFactorRequiredResponse>> => {
  return request.post({ url: '/auth/login', data })
}

export const verify2FAApi = (data: TwoFactorVerifyType): Promise<IResponse<LoginResponse>> => {
  return request.post({ url: '/auth/verify-2fa', data })
}

// 2FA 管理接口
export const get2FAStatusApi = (): Promise<
  IResponse<{
    enabled: boolean
    enabledAt?: string
    hasBackupCodes: boolean
    backupCodesCount: number
  }>
> => {
  return request.get({ url: '/auth/2fa/status' })
}

export const generate2FASecretApi = (): Promise<
  IResponse<{
    secret: string
    qrCodeUrl: string
    message: string
  }>
> => {
  return request.post({ url: '/auth/2fa/generate' })
}

export const enable2FAApi = (data: { code: string }): Promise<
  IResponse<{
    enabled: boolean
    backupCodes: string[]
    message: string
  }>
> => {
  return request.post({ url: '/auth/2fa/enable', data })
}

export const disable2FAApi = (data: { password: string }): Promise<
  IResponse<{
    disabled: boolean
    message: string
  }>
> => {
  return request.delete({ url: '/auth/2fa/disable', data })
}

export const regenerateBackupCodesApi = (data: { password: string }): Promise<
  IResponse<{
    backupCodes: string[]
    message: string
  }>
> => {
  return request.post({ url: '/auth/2fa/regenerate-backup-codes', data })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/auth/loginOut' })
}

export const getUserListApi = ({ params }: AxiosConfig) => {
  return request.get<{
    code: string
    data: {
      list: UserType[]
      total: number
    }
  }>({ url: '/mock/user/list', params })
}

export const getAdminRoleApi = (
  params: RoleParams
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.get({ url: '/mock/role/list', params })
}

export const getTestRoleApi = (params: RoleParams): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', params })
}
